module.exports = __webpack_public_path__ + "img/KhalilAbdula.7a96fc47.jpg";